import { render } from "./Faqs.vue?vue&type=template&id=1a40bd3e&scoped=true&ts=true"
import script from "./Faqs.vue?vue&type=script&lang=ts"
export * from "./Faqs.vue?vue&type=script&lang=ts"

import "./Faqs.vue?vue&type=style&index=0&id=1a40bd3e&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a40bd3e"]])

export default __exports__